import React, { useState, useEffect } from "react";
import {
  validateDniSimulations,
  validateEmail,
  getFilteredDataKeepEmptyStrings,
} from "../../Utils/validators";
import ErrorCustom from "../../Components/errorCustom";
import Button from "../../Components/FormElements/Button";
import { typeDocumentListAsInsured } from "../../Utils/constants";
import { API } from "aws-amplify";
import { camposOpcionalesBeneficiario } from "../../Utils/utils";
import { DualRing } from "react-loading-io";
import { Ubigeo } from "./ubigeo";
import { useForm, FormContext } from "react-hook-form";
import moment from "moment";
import DateTimePicker from "react-datetime-picker";
import CalendarIcon from "../../Resources/svg/date-picker.svg";
export interface Props {
  beneficiary: any;
  existsErrors: boolean;
  validationBeneficiary: any;
  onSubmit: any;
  isOpen: any;
  type: any;
}

export const BeneficiaryFormRv = ({
  beneficiary,
  existsErrors,
  validationBeneficiary,
  onSubmit,
  isOpen,
  type,
}: Props) => {
  const methods = useForm({ mode: "onChange" });
  const { handleSubmit, register, errors, formState, setValue } = useForm({
    mode: "onChange",
  });

  const [ubigeoCode, setUbigeoCode] = useState<any>();
  const [nameUbigeo, setNameUbigeo] = useState<any>({
    province: "",
    department: "",
    district: "",
  });
  const [data, setData] = useState<any>(beneficiary);

  const [errorDateFFA, setErrorDateFFA] = useState<any>();
  const [errorDateFFI, setErrorDateFFI] = useState<any>();
  const [errorDateFP, setErrorDateFP] = useState<any>();

  const [selectDate, setSelectDate] = useState({
    fechaFallecimiento: "",
    fechaFirmaSeccionV: "",
    fechaPagoPrimaUnica: "",
  });

  const [dataClientState, setDataClient] = useState<any>();
  const [dataTypeDoc, setDataTypeDoc] = useState<any>("");
  const [isDataLoaded, setIsDataLoaded] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [validationBeneficiaryState, setValidationBeneficiary] =
    useState<boolean>(false);
  const [, forceUpdate] = useState(0);
  useEffect(() => {
    setData(beneficiary);
    if (beneficiary.tipoDoc || beneficiary.TipoDoc) {
      setDataTypeDoc(
        beneficiary.tipoDoc ? beneficiary.tipoDoc : beneficiary.TipoDoc
      );
      getInformationByDocument(
        beneficiary.nroDoc ? beneficiary.nroDoc : beneficiary.NroDoc
      );

      setValue("tipoDoc", beneficiary.tipoDoc || beneficiary.TipoDoc);
      setValue("documento", beneficiary.nroDoc || beneficiary.NroDoc);
      setValue("telefono", beneficiary.telefono || "");
      setValue("correoElectronico", beneficiary.correoElectronico || "");
      setValue("direccion", beneficiary.direccion || "");
      setValue("referencia", beneficiary.referencia || "");
      setIsDataLoaded(true);
    }

    // Cargar ubigeo independientemente del tipo de documento
    if (
      beneficiary.provincia &&
      beneficiary.provincia.trim() !== "" &&
      beneficiary.departamento &&
      beneficiary.departamento.trim() !== "" &&
      beneficiary.distrito &&
      beneficiary.distrito.trim() !== ""
    ) {
      setNameUbigeo({
        province: beneficiary.provincia,
        department: beneficiary.departamento,
        district: beneficiary.distrito,
      });
    }

    if (
      beneficiary.fechaFallecimiento &&
      beneficiary.fechaFallecimiento !== "" &&
      moment(beneficiary.fechaFallecimiento, "YYYY-MM-DD", true).isValid()
    ) {
      setSelectDate((prev) => ({
        ...prev,
        fechaFallecimiento: beneficiary.fechaFallecimiento,
      }));
    }

    if (
      beneficiary.fechaFirmaSeccionV &&
      beneficiary.fechaFirmaSeccionV !== "" &&
      moment(beneficiary.fechaFirmaSeccionV, "YYYY-MM-DD", true).isValid()
    ) {
      setSelectDate((prev) => ({
        ...prev,
        fechaFirmaSeccionV: beneficiary.fechaFirmaSeccionV,
      }));
    }

    if (
      beneficiary.fechaPagoPrimaUnica &&
      beneficiary.fechaPagoPrimaUnica !== "" &&
      moment(beneficiary.fechaPagoPrimaUnica, "YYYY-MM-DD", true).isValid()
    ) {
      setSelectDate((prev) => ({
        ...prev,
        fechaPagoPrimaUnica: beneficiary.fechaPagoPrimaUnica,
      }));
    }
  }, [beneficiary]);

  useEffect(() => {
    handleChange({ target: { name: "nameUbigeo", value: nameUbigeo } });
  }, [nameUbigeo]);

  const handleChange = async (e: any) => {
    const { name, value } = e.target;

    let typeDoc;

    let newValue = value;

    if (name === "tipoDoc") {
      typeDoc = value;
      setDataTypeDoc(typeDoc);
    } else if (name === "documento") {
      if (newValue !== "" && !validateDniSimulations(newValue, dataTypeDoc)) {
        newValue = data[name];
      }
    }

    setData((prevData: any) => ({ ...prevData, [name]: newValue }));

    if (name === "documento") {
      if (
        (value.toString().length == 8 && dataTypeDoc === "2") ||
        (value.toString().length >= 9 && dataTypeDoc === "1") ||
        (value.toString().length >= 8 && dataTypeDoc === "3")
      ) {
        try {
          getInformationByDocument(value);
        } catch (error) {
          console.error(error);
        }
      }
    }
    let errorValidation = false;
    Object.entries(errors).some((item) => {
      if (item[1] && !camposOpcionalesBeneficiario.includes(item[0])) {
        errorValidation = true;
        return true;
      }
    });
  };

  const getInformationByDocument = async (documentData: any) => {
    const dataClient = await getDataClient(documentData);
    if (dataClient) {
      setDataClient(dataClient);
      validationBeneficiary(
        validateUserWithDocumentNumber(dataClient, beneficiary)
      );
      setValidationBeneficiary(
        validateUserWithDocumentNumber(dataClient, beneficiary)
      );
    }
  };

  const transformTypeDocument = (typeDoc: any) => {
    let newDoc = typeDoc
    if(typeDoc === "1") newDoc = "4";
    if(typeDoc === "3") newDoc = "6";
    return newDoc
  }

  const getDataClient = async (value: any) => {
    const params = {
      numDocumento: value,
      tipoDocumento: transformTypeDocument(
        dataTypeDoc
          ? dataTypeDoc
          : beneficiary.tipoDoc || beneficiary.TipoDoc
      ),
    };

    try {
      setLoading(true);
      const response = await API.post("api-rentas", "/client", {
        body: params,
        headers: {},
      });
      setLoading(false);
      if (response.status === 200 && response.data && response.success) {
        return response.data;
      }

      return null;
    } catch (error) {
      setLoading(false);
      return null;
    }
  };

  const validateUserWithDocumentNumber = (
    dataBDU: any,
    beneficiary: any
  ): boolean => {
    return (
      dataBDU.apellidoPaterno == beneficiary.apellidoPaterno &&
      dataBDU.apellidoMaterno == beneficiary.apellidoMaterno
    );
  };

  const typeInputDoc = dataTypeDoc === "2" ? "number" : "text";

  const onSubmitImprovement = async (values: any) => {
    const formatDate = (date: any) => {
      if (!date) return "";
      return moment(date).isValid() ? moment(date).format("YYYY-MM-DD") : "";
    };

    const beneficiaryOrInsuredData: any = {
      id: beneficiary.id,
      [type === "BENEFICIARY" ? "TipoDoc" : "tipoDoc"]:
        values.tipoDoc ||
        dataTypeDoc ||
        beneficiary.tipoDoc ||
        beneficiary.TipoDoc,
      [type === "BENEFICIARY" ? "NroDoc" : "nroDoc"]:
        values.documento || beneficiary.nroDoc || beneficiary.NroDoc,
      departamento: nameUbigeo.department,
      direccion: values.direccion || "",
      distrito: nameUbigeo.district,
      estadoCivil: (dataClientState && dataClientState.estadoCivil) || "",
      provincia: nameUbigeo.province,
      referencia: values.referencia || "",
    };

    // Solo incluir teléfono y correo si tienen valor, o si es ASEGURADO (donde son obligatorios)
    if (type === "INSURED") {
      // Para asegurado, siempre incluir (son obligatorios)
      beneficiaryOrInsuredData.correoElectronico = values.correoElectronico;
      beneficiaryOrInsuredData.telefono = values.telefono;
      
      // Fechas solo para asegurado
      if (formatDate(selectDate.fechaFallecimiento)) {
        beneficiaryOrInsuredData.fechaFallecimiento = formatDate(selectDate.fechaFallecimiento);
      }
      if (formatDate(selectDate.fechaFirmaSeccionV)) {
        beneficiaryOrInsuredData.fechaFirmaSeccionV = formatDate(selectDate.fechaFirmaSeccionV);
      }
      if (formatDate(selectDate.fechaPagoPrimaUnica)) {
        beneficiaryOrInsuredData.fechaPagoPrimaUnica = formatDate(selectDate.fechaPagoPrimaUnica);
      }
    } else {
      // Para beneficiario, solo incluir si tienen valor
      if (values.telefono && values.telefono.trim() !== "") {
        beneficiaryOrInsuredData.telefono = values.telefono;
      }
      if (values.correoElectronico && values.correoElectronico.trim() !== "") {
        beneficiaryOrInsuredData.correoElectronico = values.correoElectronico;
      }
    }

    const request = {
      id: String(beneficiary.nroOperacion),
      [type === "BENEFICIARY" ? "beneficiario" : "asegurado"]: beneficiaryOrInsuredData,
    };
    
    onSubmit(getFilteredDataKeepEmptyStrings(request));
  };

  const handleValidationForm = () => {
    const hasUbigeo =
      nameUbigeo &&
      nameUbigeo.department &&
      nameUbigeo.department.trim() !== "" &&
      nameUbigeo.province &&
      nameUbigeo.province.trim() !== "" &&
      nameUbigeo.district &&
      nameUbigeo.district.trim() !== "";

    const hasFieldErrors =
      errors &&
      (errors.documento || errors.telefono || errors.correoElectronico);
    if (type === "INSURED") {
      const hasDocument =
        data &&
        (data.nroDoc || data.NroDoc) &&
        (data.nroDoc || data.NroDoc).toString().length > 0;
      const hasTelefono =
        data && data.telefono && data.telefono.toString().length === 9;
      const hasEmail =
        data &&
        data.correoElectronico &&
        data.correoElectronico.trim().length > 0;

      return (
        hasUbigeo && hasDocument && hasTelefono && hasEmail && !hasFieldErrors
      );
    }

    return hasUbigeo && !hasFieldErrors;
  };

  const handleDateChange = (initDate: any, type: string) => {
    if (initDate && moment(initDate).isValid()) {
      switch (type) {
        case "fechaFallecimiento":
          setSelectDate({ ...selectDate, fechaFallecimiento: initDate });
          setErrorDateFFA(null);
          break;
        case "fechaFirmaSeccionV":
          setSelectDate({ ...selectDate, fechaFirmaSeccionV: initDate });
          setErrorDateFFI(null);
          break;
        case "fechaPagoPrimaUnica":
          setSelectDate({ ...selectDate, fechaPagoPrimaUnica: initDate });
          setErrorDateFP(null);
          break;
      }
    }
  };

  useEffect(() => {
    if (!isOpen) {
      forceUpdate((prev) => prev + 1);
    }
  }, [isOpen]);

  const maxDate = new Date();

  return (
    <div className={`beneficiaryForm first`} style={{ position: "relative" }}>
      <form onSubmit={handleSubmit(onSubmitImprovement)}>
        {loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(255, 255, 255, 0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2,
            }}
          >
            <DualRing size={50} />
          </div>
        )}

        <div>
          <div
            className="clientForm__control__inputSelect"
            style={{ marginTop: "1rem" }}
          >
            <select
              ref={register}
              name={`tipoDoc`}
              value={dataTypeDoc}
              onChange={(e) => handleChange(e)}
            >
              <option value="" disabled>
                Documento
              </option>
              {typeDocumentListAsInsured &&
                typeDocumentListAsInsured.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.name}
                  </option>
                ))}
            </select>
            <div className="clientForm__control input-field">
              <input
                type={typeInputDoc}
                autoComplete="off"
                name={`documento`}
                defaultValue={data.nroDoc || data.NroDoc || ""}
                ref={register({
                  validate: {
                    required: (value) => {
                      if (!value)
                        return "Por favor ingrese un número de documento válido.";
                      return true;
                    },
                  },
                })}
                onChange={(e) => handleChange(e)}
                maxLength={dataTypeDoc == "2" ? 8 : 15}
                disabled={dataTypeDoc.length == 0}
              />
              <label
                htmlFor={`documento`}
                className={`${
                  isDataLoaded &&
                  ((data.nroDoc && data.nroDoc.length > 0) ||
                    (data.NroDoc && data.NroDoc.length > 0))
                    ? "active"
                    : ""
                }`}
              >
                Nro Documento
              </label>
            </div>
          </div>
          <ErrorCustom errors={errors} name="documento" />

          <div className="clientForm__control input-field">
            <input
              type="text"
              autoComplete="off"
              id={`telefono`}
              name={`telefono`}
              defaultValue={data.telefono || ""}
              ref={register({
                validate: (value) => {
                  if (type === "INSURED" && (!value || value === "")) {
                    return "Por favor ingrese un número de celular.";
                  }
                  if (value && value !== "") {
                    const isNumeric = /^\d+$/.test(value);
                    const isNineDigits = value.length === 9;

                    if (!isNumeric || !isNineDigits) {
                      return "Por favor ingrese un número de celular válido de 9 dígitos.";
                    }
                  }

                  return true;
                },
              })}
              onChange={(e) => {
                const newValue = e.target.value;
                if (!/^\d*$/.test(newValue) || newValue.length > 9) {
                  e.target.value = e.target.value.slice(0, -1);
                  return;
                }
                handleChange(e);
              }}
              maxLength={9}
              pattern="[0-9]*"
              inputMode="numeric"
            />
            <label
              htmlFor={`telefono`}
              className={`${
                isDataLoaded && data.telefono && data.telefono.length > 0
                  ? "active"
                  : ""
              }`}
            >
              Celular
            </label>
            <ErrorCustom errors={errors} name="telefono" />
          </div>

          <div>
            <div
              className="clientForm__control input-field is-optional2"
              style={{ marginBottom: "0px" }}
            >
              <input
                type="text"
                autoComplete="off"
                defaultValue={data.correoElectronico || ""}
                ref={register({
                  validate: (value) => {
                    if (type === "INSURED" && (!value || value === "")) {
                      return "Por favor ingrese un correo electrónico.";
                    }
                    if (value && value !== "" && validateEmail(value)) {
                      return "Por favor ingrese un email válido.";
                    }

                    return true;
                  },
                })}
                id={`correoElectronico`}
                name={`correoElectronico`}
                onChange={(e) => handleChange(e)}
              />
              <label
                htmlFor={`correoElectronico`}
                className={`${
                  isDataLoaded &&
                  data.correoElectronico &&
                  data.correoElectronico.length > 0
                    ? "active"
                    : ""
                }`}
              >
                Correo Electrónico
              </label>
              <ErrorCustom errors={errors} name="correoElectronico" />
            </div>
          </div>

          {type === "INSURED" && (
            <>
              <div className="vasForm__form__input-container-select">
                <label>fecha de fallecimiento</label>
                <div
                  className={`datapicker-single ${errorDateFFA && "is-error"}`}
                >
                  <div className="datapicker-single__body">
                    <DateTimePicker
                      name="fechaFallecimiento"
                      value={
                        selectDate.fechaFallecimiento
                          ? moment(
                              selectDate.fechaFallecimiento,
                              "YYYY-MM-DD"
                            ).toDate()
                          : null
                      }
                      format="dd-MM-yy"
                      dayPlaceholder="dd"
                      monthPlaceholder="mm"
                      yearPlaceholder="yy"
                      maxDate={maxDate}
                      onChange={(e) =>
                        handleDateChange(e, "fechaFallecimiento")
                      }
                      calendarIcon={<img src={CalendarIcon} />}
                      clearIcon={null}
                    />
                  </div>
                </div>
                {errorDateFFA && (
                  <div className="errorCustom">{errorDateFFA}</div>
                )}
              </div>
              <div className="vasForm__form__input-container-select">
                <label>fecha firma sección</label>
                <div
                  className={`datapicker-single ${errorDateFFI && "is-error"}`}
                >
                  <div className="datapicker-single__body">
                    <DateTimePicker
                      name="fechaFirmaSeccionV"
                      value={
                        selectDate.fechaFirmaSeccionV
                          ? moment(
                              selectDate.fechaFirmaSeccionV,
                              "YYYY-MM-DD"
                            ).toDate()
                          : null
                      }
                      format="dd-MM-yy"
                      dayPlaceholder="dd"
                      monthPlaceholder="mm"
                      yearPlaceholder="yy"
                      maxDate={maxDate}
                      onChange={(e) =>
                        handleDateChange(e, "fechaFirmaSeccionV")
                      }
                      calendarIcon={<img src={CalendarIcon} />}
                      clearIcon={null}
                    />
                  </div>
                </div>
                {errorDateFFI && (
                  <div className="errorCustom">{errorDateFFI}</div>
                )}
              </div>
              <div className="vasForm__form__input-container-select">
                <label>fecha pago prima única</label>
                <div
                  className={`datapicker-single ${errorDateFP && "is-error"}`}
                >
                  <div className="datapicker-single__body">
                    <DateTimePicker
                      name="fechaPagoPrimaUnica"
                      value={
                        selectDate.fechaPagoPrimaUnica
                          ? moment(
                              selectDate.fechaPagoPrimaUnica,
                              "YYYY-MM-DD"
                            ).toDate()
                          : null
                      }
                      format="dd-MM-yy"
                      dayPlaceholder="dd"
                      monthPlaceholder="mm"
                      yearPlaceholder="yy"
                      maxDate={maxDate}
                      onChange={(e) =>
                        handleDateChange(e, "fechaPagoPrimaUnica")
                      }
                      calendarIcon={<img src={CalendarIcon} />}
                      clearIcon={null}
                    />
                  </div>
                </div>
                {errorDateFP && (
                  <div className="errorCustom">{errorDateFP}</div>
                )}
              </div>
              <div className="card-verify__rows-line"></div>
            </>
          )}

          <>
            <FormContext {...methods}>
              <Ubigeo
                nameUbigeo={nameUbigeo}
                setNameUbigeo={setNameUbigeo}
                setUbigeoCode={setUbigeoCode}
                setUbigeoCodeObject={setUbigeoCode}
                errors={errors}
                isDisabled={type === "BENEFICIARY"}
              />
            </FormContext>
          </>

          <div>
            <div className="clientForm__control input-field percent">
              <input
                type="text"
                autoComplete="off"
                id={`direccion`}
                name={`direccion`}
                defaultValue={data.direccion || ""}
                ref={register}
                onChange={(e) => handleChange(e)}
                disabled={type === "BENEFICIARY"}
              />
              <label
                htmlFor={`direccion`}
                className={`${
                  data.direccion && data.direccion.length > 0 ? "active" : ""
                }`}
              >
                Dirección
              </label>
            </div>
            <div className="clientForm__control input-field percent">
              <input
                type="text"
                autoComplete="off"
                id={`referencia`}
                name={`referencia`}
                defaultValue={data.referencia || ""}
                ref={register}
                disabled={type === "BENEFICIARY"}
              />
              <label
                htmlFor={`referencia`}
                className={`${
                  data.referencia && data.referencia.length > 0 ? "active" : ""
                }`}
              >
                Referencia
              </label>
            </div>
          </div>
        </div>
        <div className="actions">
          <Button
            disabled={!handleValidationForm()}
            type="submit"
            className="actions__continue"
          >
            Guardar
          </Button>
        </div>
      </form>
    </div>
  );
};
